import * as moment from 'moment/moment';

export const environment = {
  production: false,
  api: 'https://api-loreal-crm.h2h.tech',
  capchaKey: '6Lf7pasUAAAAALOfG_nbC_8Qz3NFjqLTyTOEU4Eg',
  upload: 'https://api-loreal-crm.h2h.tech/uploads/',
  disableCart: false, // moment().isSameOrBefore('2025-01-16', 'day'),
};
